export var Variant = /*#__PURE__*/ function(Variant) {
    Variant["gray"] = "gray";
    Variant["singleColor"] = "singleColor";
    Variant["dualColor"] = "dualColor";
    Variant["boxLight"] = "boxLight";
    Variant["boxDark"] = "boxDark";
    return Variant;
}({});
export var Size = /*#__PURE__*/ function(Size) {
    Size["xs"] = "xs";
    Size["s"] = "s";
    Size["m"] = "m";
    Size["l"] = "l";
    Size["xl"] = "xl";
    Size["xxl"] = "xxl";
    Size["xxxl"] = "xxxl";
    return Size;
}({});
